'use client';
import type { PropsWithChildren } from 'react';
import { getEnv } from '@witmetrics/utils/env';
import { NODE_ENV } from '@witmetrics/utils/constants';
import { theme } from '@/utils/theme';
import { useMountEffect } from '@/hooks/useMountEffect';
import ReduxProvider from '../ReduxProvider';
import SocketsProvider from '../SocketsProvider';
import AppStateProvider from '../AppStateProvider';
import LoadedFilesProvider from '../LoadedFilesProvider';

export default function AppProviders({ children }: PropsWithChildren) {
  useMountEffect(() => {
    if (getEnv() !== NODE_ENV.PRODUCTION) window.muiTheme = theme;
  });

  return (
    <ReduxProvider>
      <SocketsProvider>
        <AppStateProvider>
          <LoadedFilesProvider>{children}</LoadedFilesProvider>
        </AppStateProvider>
      </SocketsProvider>
    </ReduxProvider>
  );
}
